import QueryString from 'query-string';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'underscore';
import moment from 'moment';
import DOCUMENTS_CONTROLLER from '../../controllers/documents';
import { API } from '../../controllers/bulkActionStatus';
import GLOBAL_FILTER_CONTROLLER from '../../controllers/globalFilter';
import { ProcessedFileRedeliver } from '../../utils/appConfig';
import ComponentUtil from '../../utils/componentUtil';
import Logger, { ALL_MESSAGES, LOG_LEVELS } from '../../utils/logger';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import { FIELDS as GLOBAL_FILTER_PANEL_FIELDS } from '../filter/GlobalFilterPanel';
import ApplicationMessages from '../inAppMessages/ApplicationMessages';
import ApplicationMessageWithDetail from '../inAppMessages/ApplicationMessageWithDetail';
import DocumentListForm from './DocumentListForm';
import ExportPanel from './ExportPanel';
import FilterPanel from './FilterPanel';
import AppConfig from '../../utils/appConfig';
import DocumentListFormV2 from './DocumentListFormV2';
import BulkOperationStatusModal from './BulkOperationStatusModal';
import { OperationTypes } from '../../utils/enums';
import ReadOnlyWrapper from '../authorization/ReadOnlyWrapper';

const PAGE_INTERNAL_IDS = [
  GLOBAL_FILTER_PANEL_FIELDS.PARAM_COMPANY_ID
];

const REDELIVER_POLL_INTERVAL = ProcessedFileRedeliver.PROCESSED_FILE_REDELIVER_POLL_INTERVAL;
const log = new Logger('PROCESSED_DOCUMENTS_PAGE', LOG_LEVELS.DEBUG);

let progressTracker;
let intervalId = 0;
let successList = []
let receivedCount = 0;
class Page extends Component {
  constructor(props) {
    super(props);
    this.state = { exportIdList: null, errorDetails: [], successDetails: [], modalTitle: '', showBulkOperationStatusModal: false };
    this.successList = [];
    this.onSearchClickHandler = this.onSearchClickHandler.bind(this);
    this.onCloseBulkOperationStatusModal = this.onCloseBulkOperationStatusModal.bind(this);
  }
  setExportIdList(idList) {
    this.setState({ exportIdList: (Array.isArray(idList) && idList.length > 0) ? idList : null });
  }

  doRequestedAction(action, documentIds) {
    log.debug('doRequestedAction(): ', action, documentIds);
    log.clearDictionaryError(ALL_MESSAGES.FILE_DELETED_SUCCESSFULLY);
    log.clearDictionaryError(ALL_MESSAGES.FILE_DELETED_ERROR);
    log.clearAllDictionaryErrors();
    if (_.isEmpty(documentIds))
      return;
    if (action === 'export') {
      this.setExportIdList(documentIds);
      return;
    }
    successList = [];
    this.setState({
      successDetails: [],
      errorDetails: []
    });

    this.props.doActionOnDocuments(action, documentIds, (errors, successes) => {
      log.debug("doActionOnDocuments - this happened", action, errors, successes);
      if (action === 'delete') {
        this.setState({
          successDetails: successes,
          errorDetails: errors,
          modalTitle: 'processedDocumentsPage_Delete'
        });
      }
      let globalFilterSelection = GLOBAL_FILTER_CONTROLLER.getAll();
      let parsedQueryParams = QueryString.parse(this.props.location.search);
      let apiParams = Object.assign({}, parsedQueryParams, globalFilterSelection);

      if (action !== 'delete') {
        if (this.props.enableNewProcessedDocumentGrid) {
          this.props.onPageLoadV2(apiParams);
        } else {
          this.props.onPageLoad(apiParams);
        }
      }

      if (action === 'redeliver') {
        this.setState({
          modalTitle: 'processedDocumentsPage_Redeliver'
        });
        log.clearDictionaryError(ALL_MESSAGES.PROCESSED_MULTIPLE_FILES_REDELIVER_ERROR);
        log.clearDictionaryError(ALL_MESSAGES.PROCESSED_MULTIPLE_FILES_REDELIVER_SUCCESS);
        log.clearDictionaryError(ALL_MESSAGES.PROCESSED_FILE_REDELIVER_ERROR);
        log.clearDictionaryError(ALL_MESSAGES.PROCESSED_FILE_REDELIVER_SUCCESS);
        documentIds = _.isArray(documentIds) ? documentIds : [documentIds];
        progressTracker = { total: documentIds.length, count: 0, documents: [] };
        for (var i = 0; i < documentIds.length; i++) {
          progressTracker.documents.push({ documentId: documentIds[i], status: 'Pending' });
        }
        //Start timer to get status
        //Call get status after every REDELIVER_POLL_INTERVAL sec (30 secs ,30000 milliseconds)
        if (intervalId > 0) {
          window.clearInterval(intervalId);
        }
        intervalId = window.setInterval(() => this.GetProcessedFileStatus(documentIds), REDELIVER_POLL_INTERVAL);
        //Scroll to top, so user can see error/success message
        window.scrollTo(0, 0);
      }
    });
  }

  doRequestedActionV2(action, documentIds) {
    log.debug('doRequestedActionV2(): ', action, documentIds);
    log.clearDictionaryError(ALL_MESSAGES.FILE_OPERATION_STARTED_SUCCESS);
    log.clearAllDictionaryErrors();
    if (_.isEmpty(documentIds))
      return;
    if (action === 'export') {
      this.setExportIdList(documentIds);
      return;
    }
    let values = this.prepareRequestForFileOperation(action, documentIds);

    this.props.doActionOnDocumentsV2(values, (errors, successes) => {
      log.debug("doActionOnDocumentsV2 - this happened", action, errors, successes);

      if (errors) {
        log.setDictionaryMessage(ALL_MESSAGES.FILE_OPERATION_ERROR);
      } else if (successes) {
        log.setDictionaryMessage(ALL_MESSAGES.FILE_OPERATION_STARTED_SUCCESS);
      }

      let globalFilterSelection = GLOBAL_FILTER_CONTROLLER.getAll();
      let parsedQueryParams = QueryString.parse(this.props.location.search);
      let apiParams = Object.assign({}, parsedQueryParams, globalFilterSelection);
    });
  }

  getBulkOperationStatus() {
    const { customerId, userId, doGetBulkOperationStatus } = this.props;

    doGetBulkOperationStatus(
      customerId,
      userId,
      () => {
        log.debug("Success fetching Operations Status");

        if (this.props.operations?.length >= 0) {
          this.setState({ showBulkOperationStatusModal: true });
        } else {
          log.setDictionaryMessage(ALL_MESSAGES.BULK_OPERATION_STATUS_NODATA);
        }
      },
      (errors) => {
        log.debug(`Error fetching operations: ${errors}`);
        log.setDictionaryMessage(ALL_MESSAGES.GET_OPERATION_STATUS_ERROR);
      }
    );
  }

  prepareRequestForFileOperation(action, documentIds) {
    return {
      documentIds: documentIds,
      action: action,
      userId: this.props.userName,
      customerId: this.props.customerId
    }
  }

  GetProcessedFileStatus(documentIds) {
    receivedCount = 0;
    for (var i = 0; i < documentIds.length; i++) {
      this.GetDocumentStatus(progressTracker.documents[i]);
    };
  }
  GetDocumentStatus(document) {
    this.props.doGetProcessedFileStatus(document.documentId.id, (documentId, status, fileName, error) => {
      receivedCount++;
      if (documentId !== undefined && !_.isEmpty(documentId) && `${status}`.toUpperCase().trim() !== 'PENDING') {
        //Simple case when only a single file is selected
        if (progressTracker.documents.length === 1) {
          if (`${status}`.toUpperCase().trim() === 'FAILED') {
            log.setDictionaryMessage(ALL_MESSAGES.PROCESSED_FILE_REDELIVER_ERROR, fileName, _.isEmpty(error) ? ` ${status}` : error);
          } else if (`${status}`.toUpperCase().trim() === 'PROCESSED') {
            log.setDictionaryMessage(ALL_MESSAGES.PROCESSED_FILE_REDELIVER_SUCCESS, fileName);
          }
        }
        //In case of multiple files sent for processing
        else {
          if (`${status}`.toUpperCase().trim() === 'FAILED') {
            let errorList = Array.isArray(this.state.errorDetails) ? this.state.errorDetails : [];
            let errorIndex = _.findIndex(errorList, err => err && err.id === fileName);
            if (errorIndex === -1) {
              errorList = _.isEmpty(this.state.errorDetails) ? this.state.errorDetails : this.state.errorDetails.slice();
              errorList = [{ id: fileName, message: error }].concat(errorList);
              log.setDictionaryMessage(ALL_MESSAGES.PROCESSED_MULTIPLE_FILES_REDELIVER_ERROR);
              this.setState({
                errorDetails: errorList,
                successDetails: []
              });
            }
          }
          //We don't care about setting up success messages if ther are any files end up in errors 
          else if (_.isEmpty(this.state.errorDetails) && `${status}`.toUpperCase().trim() === 'PROCESSED') {
            successList = Array.isArray(successList) ? successList : [];
            let successIndex = _.findIndex(successList, suc => suc && suc.id === fileName);
            if (successIndex === -1) {
              successList = [{ id: fileName, message: '' }].concat(successList);
              if (receivedCount === progressTracker.documents.length && !_.isEmpty(successList)) {
                log.setDictionaryMessage(ALL_MESSAGES.PROCESSED_MULTIPLE_FILES_REDELIVER_SUCCESS);
                this.setState({
                  successDetails: successList
                });
              }
            }
          }
        }
        for (var documentIndex in progressTracker.documents) {
          let currentDoumentId = progressTracker.documents[documentIndex] && progressTracker.documents[documentIndex].documentId;
          if (!_.isString(currentDoumentId)) {
            currentDoumentId = currentDoumentId.id;
          }
          if (currentDoumentId === documentId) {
            //Can't delete file, since timeout function using sequence range
            progressTracker.documents[documentIndex].status = status;
          }
        }
        //If no any document is Pending with redeliver, then stop timer
        var pendingDocList = progressTracker.documents.find(d => `${d.status}`.toUpperCase().trim() === 'PENDING');
        if (pendingDocList === undefined || _.isEmpty(pendingDocList)) {
          window.clearInterval(intervalId);
        }
      }
    });
  }
  doLoadDocumentDetailsHandler(documentId) {
    log.debug('doLoadDocumentDetailsHandler(): ', documentId);
    this.props.doLoadDocumentDetails(documentId);
  }
  doUnLoadDocumentDetailsHandler() {
    log.debug('doUnLoadDocumentDetailsHandler: ');
    this.props.doUnLoadDocumentDetails();
  }

  onSearchClickHandler(selection) {
    log.debug('onSearchClickHandler() - selection: ', selection);
    log.clearDictionaryError(ALL_MESSAGES.FILE_OPERATION_STARTED_SUCCESS);
    log.clearAllDictionaryErrors();
    let urlParams = Object.assign({}, selection);
    let apiParams = Object.assign({}, selection);
    PAGE_INTERNAL_IDS.forEach(key => delete urlParams[key]);
    if (this.props.enableNewProcessedDocumentGrid) {
      this.props.onPageLoadV2(apiParams);
    } else {
      this.props.onPageLoad(apiParams);
    }
    ComponentUtil.updateUrlParams(this.props.location, this.props.history, urlParams);
  }

  onCloseBulkOperationStatusModal() {
    this.setState({ showBulkOperationStatusModal: false })
  }

  componentDidMount() {
    log.debug('componentDidMount()');
    log.clearAllDictionaryErrors();
    let globalFilterSelection = GLOBAL_FILTER_CONTROLLER.getAll();
    //Do not use any date values from global filter criteria
    delete globalFilterSelection.startDate;
    delete globalFilterSelection.endDate;

    let parsedQueryParams = QueryString.parse(this.props.location.search);
    let todaysDate = new Date();
    let startDate = parsedQueryParams.startDate ? parsedQueryParams.startDate : moment.utc(todaysDate).startOf('month').format(AppConfig.DateTimeConfig.DEFAULT_MOMENT_DATE_FORMAT);
    let endDate = parsedQueryParams.endDate ? parsedQueryParams.endDate : moment.utc(todaysDate).endOf('month').format(AppConfig.DateTimeConfig.DEFAULT_MOMENT_DATE_FORMAT);

    let urlParams = Object.assign({}, parsedQueryParams, globalFilterSelection, { startDate: startDate, endDate: endDate });
    let apiParams = Object.assign({}, urlParams);
    PAGE_INTERNAL_IDS.forEach(key => delete urlParams[key]);
    if ((apiParams.companyCode !== undefined && apiParams.companyId !== undefined)
      || (apiParams.companyCode === undefined && apiParams.companyId === undefined)) {
      if (this.props.enableNewProcessedDocumentGrid) {
        this.props.onPageLoadV2(apiParams);
      } else {
        this.props.onPageLoad(apiParams);
      }
    }
    ComponentUtil.updateUrlParams(this.props.location, this.props.history, urlParams);
  }

  componentDidUpdate(prevProps) {
    if ((this.props.companyList !== prevProps.companyList) && !_.isEmpty(this.props.companyList)) {
      let parsedQueryParams = QueryString.parse(this.props.location.search) || {};
      let globalFilterValues = GLOBAL_FILTER_CONTROLLER.getAll();
      let filterCriteria = Object.assign({}, parsedQueryParams, globalFilterValues);
      if (!_.isEmpty(filterCriteria)) {
        if (this.props.enableNewProcessedDocumentGrid) {
          this.props.onPageLoadV2(filterCriteria);
        } else {
          this.props.onPageLoad(filterCriteria);
        }
      }
    }
  }

  componentWillUnmount() {
    log.clearAllDictionaryErrors();
    window.clearInterval(intervalId);
  }

  render() {
    log.debug('render(): ', this.props);
    let globalFilterSelection = GLOBAL_FILTER_CONTROLLER.getAll();
    //Do not use any date values from global filter criteria
    delete globalFilterSelection.startDate;
    delete globalFilterSelection.endDate;
    let parsedQueryParams = Object.assign({}, globalFilterSelection, QueryString.parse(this.props.location.search));
    const documentList = [].concat(this.props.uploadedDocuments || []).concat(this.props.processedDocuments || []);
    let filteredList = documentList;

    if (!_.isEmpty(parsedQueryParams.filename)) {
      const lowerCaseFileName = parsedQueryParams.filename.toLowerCase();
      filteredList = filteredList.filter((document) => {
        return document.fileName.toLowerCase().includes(lowerCaseFileName);
      });
    }

    const listForExport = this.state.exportIdList && documentList.filter((item) => {
      return this.state.exportIdList.findIndex(obj => obj.id === item.id) >= 0
    });

    // Create a flat list of only the selected child documents for export
    const listForExportV2 = this.state.exportIdList && _.flatten(
      documentList
        .filter(item => item.childRows) // Only consider parent documents
        .map(item => item.childRows) // Get all child rows
    ).filter(childDoc =>
      this.state.exportIdList.findIndex(obj => obj.id === childDoc.id) >= 0
    );

    return (
      <s-container data-test="component-processed-documents">
        <ReadOnlyWrapper>
          <div className="content-area">
            <h1><LanguageStringResolver string='processedDocumentsPage_ProcessedDocumentsLog' /></h1>
            <p><LanguageStringResolver string='processedDocumentsPage_SeeAllOfTheFilesAddedToTheSystem' /></p>
            {
              !_.isEmpty(this.state.errorDetails) ? (
                <ApplicationMessageWithDetail messageIds={
                  [ALL_MESSAGES.PROCESSED_MULTIPLE_FILES_REDELIVER_ERROR]
                }
                  messageType="applicationError"
                  messageDetails={this.state.errorDetails || []}
                  titleLanguageString={this.state.modalTitle + "ErrorDetails"}
                  setColumnWidth={false}
                />
              ) : _.isEmpty(this.state.successDetails) ? (
                <span></span>
              ) : (
                <ApplicationMessageWithDetail messageIds={
                  [ALL_MESSAGES.PROCESSED_MULTIPLE_FILES_REDELIVER_SUCCESS]}
                  messageType="applicationSuccess"
                  messageDetails={this.state.successDetails || []}
                  titleLanguageString={this.state.modalTitle + "SuccessDetails"}
                  setColumnWidth={false}
                />
              )
            }
            <ApplicationMessages
              messageIds={[
                ALL_MESSAGES.PROCESSED_FILE_REDELIVER_ERROR,
                ALL_MESSAGES.FILE_DELETED_ERROR,
                ALL_MESSAGES.FILE_DELETED_ERROR_STILL_PROCESSING,
                ALL_MESSAGES.FILE_DELETED_ERROR_FAILED_PROCESSING,
                ALL_MESSAGES.FILE_DELETED_UNHANDLED_ERROR,
                ALL_MESSAGES.FILE_DELETED_ERROR_NOT_FOUND,
                ALL_MESSAGES.FILE_DELETED_ERROR_ID_LIST,
              ]}
              messageType="applicationError" />
            <ApplicationMessages messageIds={[ALL_MESSAGES.FILE_DELETED_SUCCESSFULLY, ALL_MESSAGES.PROCESSED_FILE_REDELIVER_SUCCESS]} messageType="applicationSuccess" />
            <ApplicationMessages messageIds={[ALL_MESSAGES.PROCESSED_FILE_REDELIVER_SENT_SUCCESS]} messageType="applicationSuccess" />
            <FilterPanel
              selectedCompanyIds={parsedQueryParams.companyId}
              companySelectionFieldName={'companyId'}
              startDate={parsedQueryParams.startDate}
              endDate={parsedQueryParams.endDate}
              filename={parsedQueryParams.filename}
              onSearchClick={this.onSearchClickHandler}
              filterOption={QueryString.parse(this.props.location.search)}
            />
            {
              this.props.enableNewProcessedDocumentGrid && (
                <div>
                  <button
                    name="Status"
                    className={'secondary mb20'}
                    data-testid='status-button'
                    onClick={this.getBulkOperationStatus.bind(this)}
                  >
                    <LanguageStringResolver
                      string={'Button_ProcessedDocuments_Operation_Status'}
                      tooltip={'Button_ProcessedDocuments_Operation_Status_Extended'}
                    />
                  </button>
                </div>
              )
            }
            {
              listForExport ? (
                <ExportPanel
                  list={this.props.enableNewProcessedDocumentGrid ? listForExportV2 : listForExport}
                  filename={'ProcessedDocumentsLog'}
                  onDone={this.setExportIdList.bind(this, null)}
                />)
                : (<div></div>)
            }

            {
              filteredList ?
                (
                  this.props.enableNewProcessedDocumentGrid ?
                    (
                      <DocumentListFormV2
                        documentList={filteredList}
                        allSelected={true}
                        onRequestAction={this.doRequestedActionV2.bind(this)}
                        loadDocumentDetails={this.doLoadDocumentDetailsHandler.bind(this)}
                        documentDetails={this.props.documentDetails}
                        UnloadDocumentDetails={this.doUnLoadDocumentDetailsHandler.bind(this)}
                      />
                    )
                    :
                    (
                      <DocumentListForm
                        documentList={filteredList}
                        allSelected={true}
                        onRequestAction={this.doRequestedAction.bind(this)}
                        loadDocumentDetails={this.doLoadDocumentDetailsHandler.bind(this)}
                        documentDetails={this.props.documentDetails}
                        UnloadDocumentDetails={this.doUnLoadDocumentDetailsHandler.bind(this)}
                      />
                    ))
                :
                (<div></div>)
            }
          </div>
          <BulkOperationStatusModal
            showModal={this.state.showBulkOperationStatusModal}
            onCloseModal={this.onCloseBulkOperationStatusModal}
            operations={this.props.operations}
          />
        </ReadOnlyWrapper>
      </s-container>
    );
  }
}


// Which props do we want to inject, given the global state?
function mapStateToProps(state, props) {
  log.debug('mapStateToProps(): ', state, props);

  return {
    languages: state.languages,
    companyList: (state.companies && state.companies.data) || [],
    processedDocuments: state.documents && state.documents.processedDocuments,
    uploadedDocuments: state.documents && state.documents.uploadedFiles,
    documentDetails: state.documents && state.documents.documentDetails,
    userName: state.authentication?.data?.userName || "Unknown",
    customerId: state.authentication && state.authentication?.data && state.authentication?.data?.customerId || [],
    enableNewProcessedDocumentGrid: state.featureFlag?.data?.EnableNewProcessedDocumentGrid,
    operations: Array.isArray(state.bulkActionStatus?.operations) ? state.bulkActionStatus.operations : [],
  };
}

function mapDispatchersToProps(dispatch) {
  return {
    onPageLoad: (apiParams) => {
      dispatch(DOCUMENTS_CONTROLLER.doLoad(apiParams));
    },
    doReloadDocuments: (apiParams) => {
      dispatch(DOCUMENTS_CONTROLLER.doLoad(apiParams));
    },
    onPageLoadV2: (apiParams) => {
      dispatch(DOCUMENTS_CONTROLLER.doLoadV2(apiParams));
    },
    doReloadDocumentsV2: (apiParams) => {
      dispatch(DOCUMENTS_CONTROLLER.doLoadV2(apiParams));
    },
    doActionOnDocuments: (action, documentIds, cb) => {
      dispatch(DOCUMENTS_CONTROLLER.doActionOnDocuments(action, documentIds, cb));
    },
    doActionOnDocumentsV2: (values, cb) => {
      dispatch(DOCUMENTS_CONTROLLER.doActionOnDocumentsV2(values, cb));
    },
    doDeleteDocuments: (documentIds) => {
      dispatch(DOCUMENTS_CONTROLLER.doDeleteDocuments(documentIds));
    },
    doLoadDocumentDetails: (documentId) => {
      dispatch(DOCUMENTS_CONTROLLER.doLoadDocumentDetails(documentId));
    },
    doUnLoadDocumentDetails: () => {
      dispatch(DOCUMENTS_CONTROLLER.doUnLoadDocumentDetails());
    },
    doGetProcessedFileStatus: (fileId, cb) => {
      if (fileId !== undefined)
        dispatch(DOCUMENTS_CONTROLLER.doGetProcessedFileStatus(fileId, cb));
    },
    doGetBulkOperationStatus: (tenantId, userId, successes, errors) => {
      // only bulk file related operations
      const operationTypeIds = [
        OperationTypes.BulkDeleteFiles,
        OperationTypes.BulkRedeliverFiles
      ];
      dispatch(API.getOperations(tenantId, userId, operationTypeIds, successes, errors));
    },
  }
}

// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps, mapDispatchersToProps)(Page);